import * as React from 'react';
import styled from 'styled-components';
import { media } from '@packages/ui';
import Instagram from 'react-instagram-embed';

import { ModuleSocialEmbed } from '@packages/common';

export const Container: any = styled(Instagram)`
  overflow: hidden;
  margin: 0 -8px;
  iframe {
    max-width: none !important;
  }

  ${media.from.sm`
    margin: 0;
  `};
`;

export type InstagramEmbedProps = ModuleSocialEmbed;

export const InstagramEmbed: React.FC<InstagramEmbedProps> = ({ embedCode }) => (
  <Container url={`https://instagr.am/p/${embedCode}`} />
);
